module.exports = __webpack_public_path__ + "public/images/dungeons-dragons.fcda9982dde8885ff1eb494efa5c0072.jpg";